<template>
  <header class="header">
    <a :href="homeUrl" class="logo">
      <img src="../assets/img/huntica.svg" alt="Huntica" class="logo__image">
      <span class="logo__text d-none d-sm-block">
        {{ $t('text') }}
      </span>
    </a>
  </header>
</template>

<script>
import useHomeUrl from '@/compositions/useHomeUrl';

export default {
  name: 'VideoRoomHeader',
  setup() {
    return useHomeUrl();
  },
};
</script>

<style lang="scss" scoped>
.header {
  display: flex;
  align-items: center;
  height: 4rem;
  background: linear-gradient(270deg, #00CBF3 0%, #0A82D9 100%);
  padding: 0 2.5rem;
  position: relative;
  box-shadow: 0 2px 12px rgba(10, 130, 217, 0.25);
  &:before {
    content: '';
    width: 100%;
    height: 100%;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 1;
    background: url("../assets/img/header-bg.svg") no-repeat center;
    opacity: 0.5;
  }
}
.logo {
  display: flex;
  align-items: center;
  text-align: left;
  position: relative;
  z-index: 2;
  text-decoration: none;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 0.85;
  }
  &__text {
    width: 10.625rem;
    font-size: 0.75rem;
    line-height: 1.17;
    color: rgba(255, 255, 255, 0.9);
    margin-left: 1rem;
  }
}

@media (max-width: 959px) {
  .header:before {
    background-position-x: right;
  }
}
@media (max-width: 599px) {
  .header {
    padding: 0 1rem;
    &:before {
      background-image: url("../assets/img/header-bg-xs.svg");
    }
  }
  .logo__text {
    display: none;
  }
}
</style>

<i18n locale="en" lang="yaml">
text: Video interview service with a human face
</i18n>

<i18n locale="ru" lang="yaml">
text: Cервис видеособеседований с человеческим лицом
</i18n>
